import { render, staticRenderFns } from "./QuestionPageDialog.vue?vue&type=template&id=a2911e04&scoped=true"
import script from "./QuestionPageDialog.vue?vue&type=script&lang=ts"
export * from "./QuestionPageDialog.vue?vue&type=script&lang=ts"
import style0 from "./QuestionPageDialog.vue?vue&type=style&index=0&id=a2911e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2911e04",
  null
  
)

export default component.exports